import React from 'react';
import { Link } from 'react-router-dom';

const ProskinsLogo = ({ 
  size = 'default', 
  showTagline = true, 
  linkTo = '/',
  className = '' 
}) => {
  const sizeClasses = {
    small: {
      icon: 'w-12 h-12 text-lg',
      title: 'text-lg',
      tagline: 'text-xs'
    },
    default: {
      icon: 'w-16 h-16 text-xl',
      title: 'text-xl',
      tagline: 'text-xs'
    },
    large: {
      icon: 'w-24 h-24 text-3xl',
      title: 'text-3xl',
      tagline: 'text-lg'
    }
  };

  const currentSize = sizeClasses[size] || sizeClasses.default;

    const LogoContent = () => (
    <div className={`proskins-logo ${className}`}>
      <div className={`proskins-logo-icon ${currentSize.icon}`}>
        <img
          src="/logo.png"
          alt="PROSKINS Logo"
          className="proskins-logo-image"
        />
      </div>
      {showTagline && (
        <div className="proskins-logo-text">
          <div className={`proskins-logo-title ${currentSize.title}`}>
            PROSKINS
          </div>
          <div className={`proskins-logo-tagline ${currentSize.tagline}`}>
            THEY SCORE. YOU WIN!
          </div>
        </div>
      )}
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="proskins-logo-link">
        <LogoContent />
      </Link>
    );
  }

  return <LogoContent />;
};

export default ProskinsLogo;
